// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import zappy from '@zappy-ride/library.react.components';

zappy.PreloadsProvider.registerPresenter('commercialIncentives.presenter');
